@for (session of activeChatSession; track session.id) {
  <div class="tw-flex-1 tw-min-h-0 tw-w-full tw-overflow-hidden">
    <chatV2-view [hideNavBar]="true"
                 title="Consultation"
                 [chatUniqueObject]="session"
                 [where]="{ user, consultationSession: session }"
                 (chatLoadingStatus)="handleLoadingStatus($event)"
                 (botReplyInProcessChange)="onBotReplyInProcessChange($event)"
                 dataFunctionName="findConsultationSessionChat"></chatV2-view>
  </div>
}
